import { PlaceOrderModal } from "./PlaceOrderModal";

export default PlaceOrderModal;
